import { createAction, props } from '@ngrx/store';
import { IPromiseOfPayment } from '@dch/billing-business-logic';

export const GET_PROMISE_OF_PAYMENT_REQUEST = 'GET_PROMISE_OF_PAYMENT_REQUEST';
export const GET_PROMISE_OF_PAYMENT_SUCCESS = 'GET_PROMISE_OF_PAYMENT_SUCCESS';
export const GET_PROMISE_OF_PAYMENT_FAILURE = 'GET_PROMISE_OF_PAYMENT_FAILURE';

export const UPDATE_PROMISE_OF_PAYMENT_REQUEST =
  'UPDATE_PROMISE_OF_PAYMENT_REQUEST';
export const UPDATE_PROMISE_OF_PAYMENT_SUCCESS =
  'UPDATE_PROMISE_OF_PAYMENT_SUCCESS';
export const UPDATE_PROMISE_OF_PAYMENT_FAILURE =
  'UPDATE_PROMISE_OF_PAYMENT_FAILURE';

export const getPromiseOfPaymentRequest = createAction(
  GET_PROMISE_OF_PAYMENT_REQUEST,
  props<{ billingAccountNumber: string }>()
);

export const getPromiseOfPaymentSuccess = createAction(
  GET_PROMISE_OF_PAYMENT_SUCCESS,
  props<{ billingAccountNumber: string; promiseOfPayment: IPromiseOfPayment }>()
);
export const getPromiseOfPaymentFailure = createAction(
  GET_PROMISE_OF_PAYMENT_FAILURE,
  props<{ billingAccountNumber: string }>()
);
